import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { firstValueFrom, tap } from 'rxjs';
 

import { CidService } from './cid.service';
import { ActorService } from '@shared/actor/actor.service';

@Injectable({
  providedIn: 'root',
})
export class CidGuard implements CanActivate {
  constructor(
    private actorService: ActorService,
    private cidService: CidService
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<boolean> {
    let cid: string | null = next.queryParamMap.get('cid');
    if (cid) {
      this.updateCid(cid);
      return true;
    }

    cid = this.cidService.get();
    if (cid) return true;

    return await firstValueFrom(
      this.actorService.getAuth0User().pipe(
        tap({
          next: (user: any) => {
            const meta = user['https://app.veratrak.com/metadata'];
            const cid = meta.home || meta.companies[0];
            if (!cid) return false;

            this.updateCid(cid);
            return true;
          },
        })
      )
    );
  }

  updateCid(cid: string): void {
    this.cidService.set(cid);
  }
}
